import React, {Component} from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import { Button } from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card'
import { Typography } from 'rmwc/Typography';
import { TextField } from 'rmwc/TextField';
import { Select } from 'rmwc/Select';
import StatusMessage from '../../util/StatusMessage'
import { ListDivider } from 'rmwc/List'
import { Link } from 'react-router-dom'


class AdminDiscounts extends Component {

	constructor(props){
		super(props)
		this.state = {
			data: {

				certificationTypeId: 4,
				selectedDiscounts: '',
				availableDiscounts: [],
				certificationTypes: [],
				code: '',
				percentage: '',
				active: 1,
				page: 1,
				totalPages: '',
				searchValue: '',
			},
			formErrors: {
				pageError: '',
				searchValueError: '',
				certificationTypeIdError: '',
			},
			errorMsg: ''
		}
	}
	componentDidMount(){
		let data = Object.assign({}, this.state.data)
		let certificationTypeId = 4
		let type = 'list'
		let url = `admin/discount/list?certification_type_id=${certificationTypeId}&page_no=${data.page}&type=${type}&value=${data.searchValue}`
		let certificationTypeUrl = 'admin/certification/types'
		return api.getResponse(this.props.user.accessToken, certificationTypeUrl)
		.then((result) => {
			if(result.status === 'success'){
				data.certificationTypes = result.data
			}
			return api.getResponse(this.props.user.accessToken, url)
		}).then((result) => {
			if(result.status === 'success'){
				data.availableDiscounts = result.data
				data.totalPages = result.total_pages
			}
			else if(result.status === 'error'){
				this.setState({errorMsg: result.message})
			}
			console.log(data)
			this.setState({data: data})
		}).catch((err) => {
			this.setState({errorMsg: 'Exception.Error in fetching details'})
		})
	}

	onInputChange = (evt) => {
		let data = Object.assign({}, this.state.data)
		data[evt.target.name] = evt.target.value;
		this.setState({data: data})
	}

	handleFetch = (event, type) => {
		let data = Object.assign({}, this.state.data)
		let errorObj = Object.assign({}, this.state.formErrors)
		let error = false
		errorObj.pageError = ''
		errorObj.searchValueError = ''
		errorObj.certificationTypeIdError = ''

		if(type === undefined || type === '' || type === null){
			type = "list"
		}

		if(!data.page){
			errorObj.pageError = "Please provide a page number"
			error = true
		}
		else if(!data.certificationTypeId){
			errorObj.certificationTypeIdError= "Please choose a certification"
			error = true
		}

		if((type === 'search') && ((!data.searchValue) || (data.searchValue === '-'))){
			errorObj.searchValueError = "Please provide a search value to proceed"
			error = true
		}

		if(!error){
			let url = `admin/discount/list?certification_type_id=${data.certificationTypeId}&page_no=${data.page}&type=${type}&value=${data.searchValue}`
			return api.getResponse(this.props.user.accessToken, url)
			.then((result) => {
				if(result.status === 'success'){
					data.availableDiscounts = result.data
					data.totalPages = result.total_pages
					this.setState({data: data, errorMsg: '', formErrors: errorObj})
				}
				else if(result.status === 'error'){
					data.availableDiscounts = []
					data.page = 1
					data.totalPages = ''
					this.setState({errorMsg: result.message, data: data, formErrors: errorObj})
				}
			}).catch((err) => {
				this.setState({errorMsg: 'Exception.Error in fetching details'})
			})
		}
		else{
			this.setState({formErrors: errorObj})
		}
	}


	handleCertificationTypeChange = (evt) => {
		let data = Object.assign({}, this.state.data)
		data.certificationTypeId = evt.target.value
		this.setState({data: data})
	}

	handleDiscountView = (evt, discountId) => {
		evt.preventDefault();
    this.props.history.push(`/portal/app/admin/discount/change/${discountId}`)
	}

	handleClear = (evt) => {
		evt.preventDefault()
		let data = Object.assign({}, this.state.data)
		data.searchValue = ''
		data.page = 1
		data.availableDiscounts = []
		data.certificationTypeId = 4
		data.totalPages = ''
		this.setState({data: data, errorMsg: ''})
	}

	render(){

		let certificationComponent
		let discountListComponent
		let searchComponent
		let activeState
		let handleDiscountView = this.handleDiscountView
		let handleFetch = this.handleFetch

		certificationComponent = (
			<GridCell span="4">
				<Select
					onChange={this.handleCertificationTypeChange}
					value = {this.state.data.certificationTypeId}
					className="select-component"
				>
				{this.state.data.certificationTypes.map(certification => (
					<option key={certification.id} value={certification.id}>{certification.name}</option>
				))}

				</Select>
			</GridCell>
		)

		searchComponent = (
			<GridCell span="10">
				<TextField className='text-input' label="Search Value" name="searchValue" onChange={this.onInputChange} value={this.state.data.searchValue} />
				<Button dense onClick={(e) => handleFetch(e, 'search')}>Fetch</Button>
				<Button dense onClick={this.handleClear}>Clear</Button>
			</GridCell>
			)

		if(this.state.data.availableDiscounts.length > 0){
			discountListComponent = (
				<tbody>
					{this.state.data.availableDiscounts.map(function(discount){
						discount.active ? activeState="Active" : activeState="InActive"
						return(<tr>
								<td>{discount.id}</td>
								<td>{discount.code}</td>
								<td>{discount.percentage}</td>
								<td>{activeState}</td>
								<td><Button dense onClick={((e) => handleDiscountView(e, discount.id))}>Update</Button></td>
								<td>{discount.certification_type}</td>
								<td>{discount.created_at}</td>
								<td>{discount.updated_at}</td>
							</tr>)
					})}
				</tbody>
			)
		}

		return(
			<div>
				<Grid>
					<GridCell span="12">
						<Card style={{padding: '25px', textAlign: 'center'}}>
							<Typography use="headline5">Discounts</Typography>
						</Card>
					</GridCell>
				</Grid>
				
				<Grid>
					<GridCell span="12">
						<Card style={{padding: '25px'}}>
							<Link to="/portal/app/admin/discount/change/0"> Add Discount </Link>
						</Card>
					</GridCell>
				</Grid>

				<Grid>
					{certificationComponent}
						<Button dense style ={{height: '75px'}} onClick={(e) => handleFetch(e, 'list')}>Fetch</Button>
					{searchComponent}

					<GridCell span="12">
						<ListDivider/>
					</GridCell>

					<GridCell span="8">
						<Typography use="subtitile">Total Pages - {this.state.data.totalPages}</Typography> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						<TextField className="text-input" type='number' label = "Page" name="page" onChange={this.onInputChange} value={this.state.data.page} />
						<Button dense onClick={this.handleFetch}>Fetch</Button>
					</GridCell>
				</Grid>

				<GridCell span="12">
        	<StatusMessage error_msg = {this.state.errorMsg}/>
        	<StatusMessage error_msg = {this.state.formErrors.pageError} />
        	<StatusMessage error_msg = {this.state.formErrors.certificationTypeIdError} />
        	<StatusMessage error_msg = {this.state.formErrors.searchValueError} />
        </GridCell>

        <br/>
				<div>
          <table className="admin-table">
            <th>Id</th>
            <th>Code</th>
            <th>Percentage</th>
            <th>Active</th>
            <th>Action</th>
            <th>Certification Type</th>
            <th>Created At</th>
            <th>Updated At</th>
            {discountListComponent}
          </table>
        </div>

			</div>
		)
	}
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminDiscounts);




// WEBPACK FOOTER //
// ./src/views/admin/AdminDiscounts.jsx